import { IconDownload, IconFile, IconX } from "@tabler/icons-react";

interface FileCardProps {
  name: string;
  onDelete?: () => void;
  onDownload?: () => void;
}

export const FileCard: React.FC<FileCardProps> = ({
  name,
  onDelete,
  onDownload,
}) => {
  return (
    <div className="flex w-72 rounded-md shadow-xs">
      <div className="flex flex-1 items-center justify-between truncate rounded-md border border-border-light bg-white select-none">
        <div className="px-2 py-2">
          <IconFile aria-hidden="true" className="h-3 w-3 text-gray-400" />
        </div>

        <div className="flex-1 truncate py-2 text-sm font-medium text-foreground">
          {name}
        </div>
        <div className="shrink-0">
          {onDownload ? (
            <button
              className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-transparent bg-white text-gray-400 hover:text-muted-foreground focus:outline-hidden"
              onClick={onDownload}
              type="button"
            >
              <span className="sr-only">Download file</span>
              <IconDownload aria-hidden="true" className="h-4 w-4" />
            </button>
          ) : null}
          {onDelete ? (
            <button
              className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-transparent bg-white text-gray-400 hover:text-muted-foreground focus:outline-hidden"
              onClick={onDelete}
              type="button"
            >
              <span className="sr-only">Delete file</span>
              <IconX aria-hidden="true" className="h-5 w-5" />
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};
